<script setup>
import PortalWrapper from '@/components/portal/PortalWrapper.vue'
import PortalForm from '@/components/portal/PortalForm.vue'
import FormField from '@/components/shared/form/FormField.vue'
import TextInput from '@/components/shared/form/TextInput.vue'
import ActionButton from '@/components/shared/buttons/ActionButton.vue'
import Alert from '@/components/shared/core/Alert.vue'
import {useEmployeePortal} from '@/composables/use-employee-portal.js'
import {computed, ref, useTemplateRef} from 'vue'

//Get employee portal composable
const {
  isCoats,
  loginEndpointUrl,
  loginErrorMessage,
} = useEmployeePortal()

//Wording for white labelling
const welcomeMessage = computed(() => {
  if (isCoats.value) {
    return 'Welcome to Coats training'
  }
  return 'Welcome to Arist training'
})
const loginPrompt = computed(() => {
  if (isCoats.value) {
    return 'Please enter your Coats employee ID to begin your required training.'
  }
  return 'Please enter your employee ID to begin your required training.'
})

//Employee ID model
const employeeId = ref('')
const trimmedEmployeeId = computed(() => employeeId.value.trim())
const setEmployeeId = value => employeeId.value = value

//Form handling
const portalForm = useTemplateRef('portalForm')
const isSubmitting = ref(false)
const doLogin = () => {
  if (!trimmedEmployeeId.value || isSubmitting.value) {
    return
  }
  isSubmitting.value = true
  portalForm.value.form.submit()
}
</script>

<template>
  <PortalWrapper
    :heading="welcomeMessage"
    :sub-heading="loginPrompt"
  >
    <Alert
      v-if="loginErrorMessage"
      type="danger"
      :text="loginErrorMessage"
      is-spaced
    />

    <PortalForm
      ref="portalForm"
      tag="form"
      name="login"
      method="post"
      :action="loginEndpointUrl"
    >
      <FormField label="Employee ID">
        <TextInput
          :value="employeeId"
          autocomplete="off"
          name="employee_id"
          @input="setEmployeeId($event.value)"
        />
      </FormField>

      <template #buttons>
        <ActionButton
          label="Log in"
          type="primary"
          is-block
          :is-disabled="!trimmedEmployeeId"
          :has-spinner="isSubmitting"
          @click="doLogin()"
        />
      </template>
    </PortalForm>
  </PortalWrapper>
</template>
